import { Loader } from "@certn/cascadia-react";
import { useQuickscreenPageLogic } from "./hooks/useQuickscreenPageLogic";
import { QuickscreenApplication } from "./QuickscreenApplication";

export function QuickscreenPage() {
  const { started } = useQuickscreenPageLogic();

  if (!started) {
    return <Loader overlay />;
  }

  return <QuickscreenApplication />;
}
